<div class="panel sticky-footer">
  <header class="panel-header">
    <h1 class="heading" i18n="@@marketplace.advancedSearchMask.titleFilter">Filter</h1>
    <button (click)="close()" class="cancel" i18n="@@marketplace.advancedSearchMask.btnClose">Schliessen</button>
  </header>
  <div [formGroup]="form" class="panel-content">
    <div class="grid">
      <div [class]="{'span-8': auth.isGiver, 'span-12': auth.isRecipient}" class="form-group">
        <label class="label" for="input-location"
        i18n="@@marketplace.advancedSearchMask.placeOfUse">Einsatzort</label>
        <ng-select #locationSelect
          (change)="updateLocation($event)"
          (keydown.delete)="clearLocation()"
          [formControl]="locationControl"
          [items]="locations$ | async"
          [typeahead]="locationInput$"
          bindLabel="zipAndName"
          class="typeahead"
          i18n-placeholder="@@marketplace.advancedSearchMask.placeOfUsePlaceholder"
          i18n-typeToSearchText="@@shared.giverOffer.placeholder.plzTypeToSearchText"
          labelForId="input-location"
          notFoundText="Keine Treffer"
          placeholder="Einsatzort auswählen..."
          typeToSearchText="PLZ/Ortsnamen eingeben">
        </ng-select>
        @if (locationControl.invalid && (locationControl.touched || locationControl.dirty)) {
          <div
            class="validation error" i18n="@@marketplace.advancedSearchMask.invlaidPlaceOfUse">Bitte wählen Sie
                    den Einsatzort aus.
                </div>
        }
      </div>

      @if (auth.isGiver) {
        <div class="form-group span-4">
          <label class="label" for="input-range" i18n="@@marketplace.advancedSearchMask.area">Einsatzgebiet (in
                    Kilometer)</label>
          <ng-select
            [clearable]="false"
            [searchable]="false"
            appAddIconChevronDown
            formControlName="range"
            labelForId="input-range">
            <ng-option value="5">5</ng-option>
            <ng-option value="10">10</ng-option>
            <ng-option value="25">25</ng-option>
            <ng-option value="50">50</ng-option>
            <ng-option value="100">100</ng-option>
          </ng-select>
          @if (rangeControl.invalid && (rangeControl.touched || rangeControl.dirty)) {
            <div
              class="validation error">
              @if (rangeControl.errors.required) {
                <span
                i18n="@@marketplace.advancedSearchMask.areaInvalidRequired">Bitte wählen Sie Ihren Einsatzradius aus.</span>
              }
              @if (rangeControl.errors.min) {
                <span i18n="@@marketplace.advancedSearchMask.areaInvalidMin">Der Radius muss mindestens 1&nbsp;km betragen.</span>
              }
            </div>
          }
        </div>
      }

      <div class="form-group span-12">
        <label class="label" id="input-assistance-services">
          <ng-container i18n="@@marketplace.advancedSearchMask.services">Dienstleistungen</ng-container>
          <abbr class="req-label" i18n-title="@@main.alt.required" title="Pflicht">*</abbr>
        </label>
        <div
          class="form-group span-12 information-text information-text--not-shure-terms"
          i18n="@@recipientOffer.informationText.notShureTerms"
          >Sind sie nicht ganz sicher, was die untenstehenden Begriffe bedeuten oder welche Aufgaben damit
                    verbunden sind? Kein Problem <a [href]="linkToFilterDescription" target="_blank">lesen sie es hier
                        nach.</a></div>
        <app-tag-selector
          (valueChange)="assistanceServicesControl.setValue($event); assistanceServicesControl.markAsDirty();"
          [selectableTags]="availableAssistanceServices$ | async"
          [value]="assistanceServicesControl.value"
          labelledby="input-assistance-services">
        </app-tag-selector>
      </div>

      <div class="form-group span-12">
        <label class="label" i18n="@@marketplace.advancedSearchMask.typeOfAssistance" id="input-kind">Art der
                    Assistenz</label>
        <app-segment-button-list
          (valueChange)="compensationControl.setValue($event); compensationControl.markAsDirty();"
          [selectableTags]="availableKinds$ | async"
          [value]="compensationControl.value"
          labelledby="input-kind">
        </app-segment-button-list>
      </div>

      <div class="span-12">
        <div class="form-group">
          <label class="label" for="input-languages" i18n="@@marketplace.advancedSearchMask.languages">Sprachen</label>
          <ng-select [clearable]="false"
            [formControl]="addSelectedLanguageControl"
            [items]="availableLanguages"
            appAddIconChevronDown
            bindLabel="name"
            i18n-placeholder="@@marketplace.advancedSearchMask.languagesPlaceholder"
            labelForId="input-languages"
            placeholder="Hinzufügen...">
          </ng-select>
        </div>

        <div class="form-group">
          <app-tag-selector (valueChange)="languagesControl.setValue($event); languagesControl.markAsDirty();"
            [selectableTags]="favoriteLanguages"
            [value]="languagesControl.value"
            labelledby="input-assistance-services">
          </app-tag-selector>
        </div>
      </div>

      <div class="form-group span-12">
        <label class="label" i18n="@@marketplace.advancedSearchMask.sex"
        id="input-gender">Wunschgeschlecht</label>
        <app-segment-button-list (valueChange)="genderControl.setValue($event); genderControl.markAsDirty();"
          [selectableTags]="availableGenders$ | async"
          [value]="genderControl.value"
          labelledby="input-gender">
        </app-segment-button-list>
      </div>

    </div>
  </div>
  <div class="panel-footer">
    <button (click)="close()" class="button primary block-xs" i18n="@@marketplace.advancedSearchMask.btnSearch">
            Suchen
        </button>
  </div>
</div>
